export const FETCH_STREAMING_PLATFORM_DATA_REQUEST = 'FETCH_STREAMING_PLATFORM_DATA_REQUEST'
export const FETCH_STREAMING_PLATFORM_DATA_FAILURE = 'FETCH_STREAMING_PLATFORM_DATA_FAILURE'
export const FETCH_STREAMING_PLATFORM_DATA_SUCCESS = 'FETCH_STREAMING_PLATFORM_DATA_SUCCESS'